import type { AxiosPromise } from 'axios'
import type { AgentFeedbackData } from './AgentFeedbackHttp.types'
import { API } from '@signifyd/http'

export const updateAgentFeedbackTags = (
  agentFeedbackData: AgentFeedbackData
): AxiosPromise =>
  API.post('/v3/orders/events/agents/feedback', agentFeedbackData)
export default updateAgentFeedbackTags
